import { CaseData } from "@/cms/models";
import AreaDetail from "../AreaDetails";
import NumberDetail from "../NumberDetails";
import TextDetails from "../TextDetails";
import PropertyDetails from "../PropertyDetails";
import EnergyLabel from "./EnergyLabel";
import {
  getCaseClassification,
  getEstateFacilities,
  isRental,
} from "@/utils/helper";
import BuiltYearDetails from "./propertyfacts/BuiltYearDetails";

interface PropertyFactProps {
  caseData: CaseData;
}

const DefaultPropertyFacts: React.FC<PropertyFactProps> = ({ caseData }) => {
  const caseClassification = getCaseClassification(caseData);
  const isCommercialRent =
    caseData.isCommercial && isRental(caseClassification);

  return (
    <div className="p-4 bg-[var(--box-bg-color)] text-[var(--box-text-color)] homepage-text-sm">
      {caseData.floorArea > 0 && (
        <AreaDetail label="Etageareal" value={caseData.floorArea} />
      )}
      {!isCommercialRent && caseData.housingArea > 0 && (
        <AreaDetail label="Boligareal" value={caseData.housingArea} />
      )}
      {!isCommercialRent && caseData.commercialArea > 0 && (
        <AreaDetail label="Erhvervsareal" value={caseData.commercialArea} />
      )}
      {caseData.otherAreas > 0 && (
        <AreaDetail label="Sekundært areal" value={caseData.secondaryArea} />
      )}
      {caseData.basementArea > 0 && (
        <AreaDetail label="Kælderareal" value={caseData.basementArea} />
      )}
      {caseData.garageArea > 0 && (
        <AreaDetail label="Garage" value={caseData.garageArea} />
      )}
      {caseData.carportArea > 0 && (
        <AreaDetail label="Carport" value={caseData.carportArea} />
      )}
      {caseData.shedArea > 0 && (
        <AreaDetail label="Udhus" value={caseData.shedArea} />
      )}
      {caseData.outdoorArea > 0 && (
        <AreaDetail label="Udenomsareal" value={caseData.outdoorArea} />
      )}
      {caseData.plotArea > 0 && (
        <AreaDetail
          label="Grundareal"
          value={caseData.plotArea}
          useHectares={false}
        />
      )}
      {caseData.numberOfRooms > 0 && (
        <NumberDetail label="Værelser" value={caseData.numberOfRooms} />
      )}
      {caseData.whereOfNumberOfLivingRooms > 0 && (
        <NumberDetail
          label="Heraf stuer"
          value={caseData.whereOfNumberOfLivingRooms}
        />
      )}
      {caseData.noOfStories > 0 && (
        <NumberDetail label="Antal plan" value={caseData.noOfStories} />
      )}
      {caseData.yearBuilt > 0 && (
        <BuiltYearDetails
          label="Byggeår"
          yearBuilt={caseData.yearBuilt}
          yearRenovationAddition={caseData.yearRenovationAddition}
        />
      )}
      {caseData.caseNumber && (
        <TextDetails label="Sagsnummer" value={caseData.caseNumber} />
      )}
      {caseData.estateType && (
        <TextDetails label="Ejendomstype" value={caseData.estateType} />
      )}
      {caseData.energyLabel && (
        <PropertyDetails
          label="Energimærke"
          value={caseData.energyLabel}
          showUnit={false}
        >
          <EnergyLabel energyLabel={caseData.energyLabel} />
        </PropertyDetails>
      )}

      {getEstateFacilities(caseData).map((taxon) => (
        <TextDetails
          key={taxon.taxonNamespace}
          label={taxon.taxonDisplayName}
          value={taxon.note ? taxon.note.substring(0, 25) : "Ja"}
        />
      ))}
    </div>
  );
};

export default DefaultPropertyFacts;
